export const EventsPathType = {
  Root: '/events',
};
